export default __webpack_public_path__ + "0cfd6489536ec0987466795401497368.png";